import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class HostCancelSpaceUnavailableModal extends React.Component {
  render () {
    const { onClose, spaceId } = this.props;
    return (
      <BootstrapModal
        onClose={onClose}
        modalClass="host-cancel-space-unavailable-modal"
        showModal
        banner={{
          type: 'success',
          text:
            <ul className="list-inline" style={{ marginBottom: 0 }}>
              <li className="v-center"><i className="ico ico-lg icon-yes" style={{ color: 'white' }} /></li>
              <li className="v-center"><FormattedMessage id='inbox.host_cancel_space_unavailable_modal.cancelled_booking' defaultMessage='You have cancelled this booking' /></li>
            </ul>
        }}
        header={<div className="h3"><FormattedMessage id='inbox.host_cancel_space_unavailable_modal.calendar_out_date' defaultMessage='Your calendar is out of date' /></div>}
        body={
          <div>
            <p className="text-center"><FormattedMessage id='inbox.host_cancel_space_unavailable_modal.unexcused_cancellation' defaultMessage='Cancelling due to availability is an unexcused cancellation and may result in penalties to your account. Update your calendar to let guests know this time is unavailable.' /></p>
            <a href={`/calendar/${spaceId}#a=block-day&source=cancel`} className="btn btn-block btn-primary classic"><FormattedMessage id='inbox.host_cancel_space_unavailable_modal.block_time' defaultMessage='Block Time' /></a>
            <a href={`/calendar/${spaceId}/settings`} className="btn btn-block btn-default classic"><FormattedMessage id='inbox.host_cancel_space_unavailable_modal.sync_calendar' defaultMessage='Sync Calendar' /></a>
          </div>
        }
        modalSize="sm-size"
      />
    );
  }
}

HostCancelSpaceUnavailableModal.propTypes = {
  onClose: PropTypes.func,
  spaceId: PropTypes.string
};
